import { Col, Row } from 'react-bootstrap'
import '../styles/Button.css'

const Button = ({ iconButton = false, iconBtnText = '', icon = null, onClick = () => { },
  cancelBtn, submitBtn, loading, disabled, submitText = "Save", isShowCancel = true,
  type = "submit", buttonExtraCss = "", shouldRow = true, isShowSubmitBtn = true,
  cancelBtnText = 'Cancel', cancelBtnDisabled = false, cancelTabIndex, submitTabIndex,
  loadingText = 'Loading...' }) => {
  return (
    <>
      {
        shouldRow ?
          <Row className='action_btn_row'>
            {
              isShowCancel &&
              <Col md={3} className='action_btn_col action_btn_cancel_col'>
                <button className='cancel_btn' type='button' onClick={cancelBtn} disabled={cancelBtnDisabled} tabIndex={cancelTabIndex}>Cancel</button>
              </Col>
            }
            {
              isShowSubmitBtn &&
              <Col md={isShowCancel ? 9 : 12} className='action_btn_col action_btn_submit_col'>
                <button
                  type={type}
                  className={`main_btn ${buttonExtraCss}`}
                  onClick={submitBtn}
                  disabled={disabled || loading}
                  tabIndex={submitTabIndex}
                >
                  {loading ? loadingText : submitText}
                </button>
              </Col>
            }
          </Row> :
          iconButton ?
            <button
              type={type}
              className={`main_btn ${buttonExtraCss} d-flex align-items-center gap-2`}
              onClick={onClick}
              disabled={disabled || loading}
              tabIndex={submitTabIndex}
            >
              {icon}
              {loading ? loadingText : iconBtnText}
            </button> :
            <>
              {isShowCancel && <button className='cancel_btn' type='button' onClick={cancelBtn} disabled={cancelBtnDisabled} tabIndex={cancelTabIndex}>{cancelBtnText}</button>}
              {
                isShowSubmitBtn &&
                <button
                  type={type}
                  className={`main_btn ${buttonExtraCss}`}
                  onClick={submitBtn}
                  disabled={disabled || loading}
                  tabIndex={submitTabIndex}
                >
                  {loading ? loadingText : submitText}
                </button>
              }
            </>
      }
    </>
  )
}

export default Button
